<template>
  <div
    v-html="data"
  />
</template>

<script>
import { findAppPrivacyAgreement } from '@/api/agreement'
export default {
  name: 'AppPrivate',
  data() {
    return {
      data: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findAppPrivacyAgreement().then((res) => {
        if (res.code === 0) {
          console.log(res.data)
          this.data = res.data.content
        }
      })
    }
  }
}
</script>

